export const parseLogStr = str => {
  const pattern = /\[{3}(.*?)\]{3}/g
  const results = str.match(pattern)
  if (!results) return str
  let params = ''
  let htmStr = ''
  results.forEach(item => {
    params = item.replace(/\[{3}|\]{3}/g, '').split('|||')
    htmStr = `<span style="color:${params[2]}">${params[0]
      .replace('\\[\\', '[')
      .replace('\\]\\', ']')}</span>`
    str = str.replace(/\[{3}(.*?)\]{3}/, htmStr)
  })
  return str
}

/**
 * 字符串打马赛克，如：9991234000返回999****000
 * @param {String} str 字符串
 * @param {String} mosStr 马赛克符号
 * @returns {String}
 */
export function addMosaic(str, mosCount = 4, mosStr = '*') {
  if (!str) {
    return
  }
  const len = str.length
  const baseMos = mosStr.repeat(mosCount)
  if (len < mosCount) {
    return baseMos
  }
  const half = Math.floor(len / 2)
  const halfL = half - Math.floor(mosCount / 2)
  const halfR = half + Math.ceil(mosCount / 2)
  return `${str.slice(0, halfL)}${baseMos}${str.slice(halfR, len)}`
}

/**
 * 从对象中排除空值
 * @param obj - 要过滤的对象
 * @param [valArr] - 要从对象中排除的值数组。
 * @returns 排除指定值后的对象
 */
export function excludeNullValue(obj, valArr = ['', null, undefined]) {
  if (!obj) {
    return
  }
  const newObj = {}
  // { a: 1, b: c } => Object.keys(): Array<String>  String = key ['a', 'b']
  Object.keys(obj).forEach(k => {
    const _c = obj[k]
    if (!valArr.includes(_c)) {
      newObj[k] = _c
    }
  })
  // for (const k in obj) {
  //   const v = obj[k]
  //   if (valArr.includes(v)) {
  //     continue
  //   }
  //   newObj[k] = v
  // }
  return newObj
}

/**
 * 获取变量类型（比typeof更加准确，能够区分 Array | Object 等特殊对象）
 * @param {String} val
 * @returns 类型
 */
export const getTypeof = (val) => Object
  .prototype
  .toString
  .call(val)
  .slice(8, -1)

export const sleep = (delay) =>
  new Promise((resolve) => setTimeout(resolve, delay))

/**
* 自定义格式化日期
* @param {Date String} date[必须] Date() 对象 或 日期字符串
* @param {String} format[可选] （默认值：dd/MM/yyyy hh:mm:ss）支持 yyyy-MM-dd hh:mm:ss等常用日期格式
* @param {String} clearTimeZone[可选] 去掉时区字符串 '2022-09-09T12:00:00.00000Z' -> 2022-09-09T12:00:00
* @returns
*/
export function formatDate(dt, fmt = 'yyyy-MM-dd hh:mm:ss') { // author: meizz
  if (!dt) {
    return ''
  }
  if (getTypeof(dt) === 'String') {
    dt = new Date(dt)
  }

  const o = {
    'M+': dt.getMonth() + 1, // 月份
    'd+': dt.getDate(), // 日
    'h+': dt.getHours(), // 小时
    'm+': dt.getMinutes(), // 分
    's+': dt.getSeconds(), // 秒
    'q+': Math.floor((dt.getMonth() + 3) / 3), // 季度
    S: dt.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt
      .replace(
        RegExp.$1,
        (`${dt.getFullYear()}`).substr(4 - RegExp.$1.length)
      )
  }

  Object.keys(o).forEach(k => {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt
        .replace(
          RegExp.$1,
          (RegExp.$1.length === 1)
            ? (o[k])
            : ((`00${o[k]}`).substr((`${o[k]}`).length))
        )
    }
  })
  return fmt
}

/**
 * 节流函数
 * @param {*} fn 回调
 * @param {*} delay 执行间隔时间 ms
 * @returns
 */

export const throttle = function(fn, delay = 15) {
  let timer = null

  return function(...args) {
    if (!timer) {
      const context = this
      // const args = arguments

      timer = setTimeout(() => {
        fn.apply(context, args)

        timer = null
      }, delay)
    }
  }
}
export const debounce = function debounce(fun, wait = 500) {
  let timer = null
  return function(...args) {
    const context = this

    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fun.apply(context, args)
    }, wait)
  }
}
export const downloadFileByPath = (path) => {
  let a = document.createElement('a')
  a.href = path
  const url = path
  const filename = url.substring(url.lastIndexOf('/') + 1)
  a.download = filename
  a.click()
  a = null
}

/**
 * 金额转换
 * @param {Number} value
 * @returns
 */
export function formatPrice(value = '') {
  if (!value) return value
  const [integer, decima] = value.toString().split('.')
  const integerFormat = String(integer).replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,')
  return decima ? `${integerFormat}.${decima}` : integerFormat
}

/**
 * 对象传入直接过滤掉null、''、undefined后返回
 * @param {对象} obj
 */
export function removeEmpty(obj) {
  Object.keys(obj).forEach((k) => (obj[k] === null || obj[k] === undefined || obj[k] === '') && delete obj[k])
}

/**
 * 逗号分隔转数组
 * @param {字符串} str
 * @returns
 */
export function commaSeparatedToArr(str) {
  if (!str) return []
  return str.split(',').map(item => item.trim()).filter(item => item)
}

/**
 * 手机号格式化， 过滤掉+254 、 +86开头的
 * @param {字符串} str
 */
export function replacePhone(str) {
  return str.replace(/^(\+254|\+86|254|86)/gm, () => {
    return ''
  })
}

/**
 * 转英文日期显示
* @param {正常时间} i
 * @param {是否显示小时} notShowHours  false 或不传: May 13, 2024 09:58, true: May 28, 2024
 * @returns
 */
export function dateFormat(i, notShowHours) {
  if (this.$store.state.locale !== 'en' || !i) {
    return i
  }
  const time = !notShowHours
    ? `${new Date(i).toDateString()
      .split(' ')[1]
    } ${
      new Date(i).getDate()
    }, ${
      new Date(i).getFullYear()
    } ${
      new Date(i).getHours() <= 9 ? `0${new Date(i).getHours()}` : new Date(i).getHours()
    }:${
      new Date(i).getMinutes() <= 9 ? `0${new Date(i).getMinutes()}` : new Date(i).getMinutes()}`
    : `${new Date(i).toDateString()
      .split(' ')[1]
    } ${
      new Date(i).getDate()
    }, ${
      new Date(i).getFullYear()
    } `
  return time
}

/**
 * 数字末尾加*号， 默认最后三位不展示用*号代替
 * @param {最后几位加*} size
 * @returns
 */
export function maskChars(input, size = 3) {
  if (!input) return input
  // 将输入转换为字符串
  const str = String(input)
  // 如果字符串长度小于等于3或者不是纯数字，返回相应数量的星号
  if (str.length <= size || /^\d+$/.test(str) === false) {
    return str
  }
  // 返回前面部分加上三个星号
  return `${str.slice(0, -size)}***`
}

/**
     * 计算本周至今,本季度至今,年初至今,过去多少个月
     * @param type week, month, quarter, year, monthsAgo
     * @param value 过去多少个月
     */
export function calculateDateRange(type, value) {
  const today = new Date()
  const todayTime = new Date()
  const timeStyle = 'yyyy-MM-dd'
  if (type === 'week') {
    const day = today.getDay() // 周日的值为0，周一到周六为1-6
    const diff = today.getDate() - day + (day === 0 ? -6 : 1)
    const weekStart = new Date(today.setDate(diff))
    return {
      start: formatDate(weekStart, timeStyle),
      end: formatDate(todayTime, timeStyle)
    }
  }
  if (type === 'month') {
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
    return {
      start: formatDate(firstDay, timeStyle),
      end: formatDate(today, timeStyle)
    }
  }
  if (type === 'quarter') {
    const quarter = Math.floor(today.getMonth() / 3)
    const quarterStart = new Date(today.getFullYear(), quarter * 3, 1)
    return {
      start: formatDate(quarterStart, timeStyle),
      end: formatDate(today, timeStyle)
    }
  }
  if (type === 'year') {
    const yearStart = new Date(today.getFullYear(), 0, 1)
    return {
      start: formatDate(yearStart, timeStyle),
      end: formatDate(today, timeStyle)
    }
  }
  // 动态月份计算
  if (type === 'monthsAgo' && value) {
    const targetMonth = new Date(today)
    targetMonth.setMonth(targetMonth.getMonth() - value)
    const monthsAgoStart = new Date(
      targetMonth.getFullYear(),
      targetMonth.getMonth(),
      1
    )
    return {
      start: formatDate(monthsAgoStart, timeStyle),
      end: formatDate(today, timeStyle)
    }
  }
}
// 生成账期选项
export function generateDateOptions() {
  const options = []
  const now = new Date()
  const currentYear = now.getFullYear()
  const currentMonth = now.getMonth()

  const getISOWeekInfo = (d) => {
    const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
    const dayNum = date.getUTCDay() || 7
    date.setUTCDate(date.getUTCDate() + 4 - dayNum)
    const weekYear = date.getUTCFullYear()
    const yearStart = new Date(Date.UTC(weekYear, 0, 1))
    const weekNo = Math.ceil((((date - yearStart) / (24 * 60 * 60 * 1000)) + 1) / 7)
    return {
      weekYear,
      weekNo
    }
  }

  for (let i = -3; i <= 3; i++) {
    let targetMonth = currentMonth + i
    let targetYear = currentYear

    while (targetMonth < 0) {
      targetMonth += 12
      targetYear--
    }
    while (targetMonth > 11) {
      targetMonth -= 12
      targetYear++
    }

    const monthLabel = `${targetYear}M${String(targetMonth + 1).padStart(2, '0')}`
    options.push({
      label: monthLabel,
      value: monthLabel
    })

    const firstDayOfMonth = new Date(targetYear, targetMonth, 1)
    const lastDayOfMonth = new Date(targetYear, targetMonth + 1, 0)

    let cursor = new Date(firstDayOfMonth)
    while (cursor <= lastDayOfMonth) {
      const { weekYear, weekNo } = getISOWeekInfo(cursor)
      const weekLabel = `${weekYear}W${String(weekNo).padStart(2, '0')}`
      if (!options.some(option => option.value === weekLabel)) {
        options.push({
          label: weekLabel,
          value: weekLabel
        })
      }
      cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 1)
    }
  }
  // 按年月周排序
  options.sort((a, b) => {
    // 提取年份
    const yearA = parseInt(a.value.substring(0, 4))
    const yearB = parseInt(b.value.substring(0, 4))
    if (yearA !== yearB) {
      return yearA - yearB
    }
    // 相同年份，比较类型和数字
    const typeA = a.value.charAt(4)
    const typeB = b.value.charAt(4)
    if (typeA !== typeB) {
      // M在W之前
      return typeA === 'M' ? -1 : 1
    }
    // 相同类型，比较数字
    const numA = parseInt(a.value.substring(5))
    const numB = parseInt(b.value.substring(5))
    return numA - numB
  })
  return options
  // this.dateOptions = options
  // 默认选中当前月份
  // const currentMonthOption = `${currentYear}M${String(currentMonth + 1).padStart(2, '0')}`
  // this.value = currentMonthOption
}

export function findRegionById(regionList, regionId) {
  if (!regionList?.length || regionId == null) {
    return null
  }
  return regionList.find(item =>
    Number(item.id) === Number(regionId) ||
    Number(item.regionId) === Number(regionId)
  )
}

export function isUgRegion(regionList, regionId) {
  return findRegionById(regionList, regionId)?.code === 'UG'
}

const REG_DOC_I18N_KEYS = {
  ug: {
    name: 'createSellerAccount.step2.nameCf',
    id: 'createSellerAccount.step2.IDCf',
    email: 'createSellerAccount.step2.emailCf',
    frontOfPassport: 'createSellerAccount.step2.frontOfPassportCf',
    doc: 'createSellerAccount.step2.cf20',
    accountNamePlaceholder: 'createSellerAccount.step2.accountNamePlaceholderCf',
    taxIdentificationNumberUpload: 'createSellerAccount.step2.taxIdentificationNumberUploadTin',
    companyUpload: 'createSellerAccount.step2.companyUploadTin'
  },
  default: {
    name: 'createSellerAccount.step2.nameCr',
    id: 'createSellerAccount.step2.IDCr',
    email: 'createSellerAccount.step2.emailCr',
    frontOfPassport: 'createSellerAccount.step2.frontOfPassport',
    doc: 'createSellerAccount.step2.cr12',
    accountNamePlaceholder: 'createSellerAccount.step2.accountNamePlaceholder',
    taxIdentificationNumberUpload: 'createSellerAccount.step2.taxIdentificationNumberUpload',
    companyUpload: 'createSellerAccount.step2.companyUpload'
  }
}

export function getRegDocI18nKeys(regionList, regionId) {
  return isUgRegion(regionList, regionId)
    ? REG_DOC_I18N_KEYS.ug
    : REG_DOC_I18N_KEYS.default
}
